import React from "react";

/**
 * Wall-Crawl loader — dangles the Raimi spider emblem from a dashed web line,
 * bobs it up and down, and slowly spins it.
 *
 * The spider is rendered via CSS mask, so it takes on the parent's `currentColor`.
 * Wrap the loader in an element with a text color (e.g. `<span className="spidey-red">`).
 */
const SPIDER_ASSET =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_money-flow-781/artifacts/dfermf2e_s-l400.png";

export default function SpiderLoader({ size = 40, label = "" }) {
  const spiderPx = Math.round(size * 0.72);
  const containerHeight = size + 18;

  const maskStyle = {
    width: spiderPx,
    height: spiderPx,
    backgroundColor: "currentColor",
    WebkitMaskImage: `url(${SPIDER_ASSET})`,
    maskImage: `url(${SPIDER_ASSET})`,
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    maskPosition: "center",
    WebkitMaskSize: "contain",
    maskSize: "contain",
    transformOrigin: "50% 30%",
  };

  return (
    <div
      className="inline-flex flex-col items-center gap-2"
      role="status"
      aria-label={label || "Loading"}
    >
      <div
        className="relative flex justify-center"
        style={{ width: size, height: containerHeight }}
      >
        {/* Dashed swaying web thread */}
        <svg
          width={size}
          height={containerHeight}
          viewBox={`0 0 ${size} ${containerHeight}`}
          className="absolute inset-0"
          aria-hidden="true"
        >
          <line
            x1={size / 2}
            y1={0}
            x2={size / 2}
            y2={containerHeight - spiderPx + 2}
            stroke="currentColor"
            strokeWidth="1"
            strokeDasharray="3 3"
            opacity="0.6"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="0"
              to="-6"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </line>
        </svg>

        {/* Dangling spider — bob wrapper + spin inner */}
        <div
          className="absolute spider-bob"
          style={{
            width: spiderPx,
            height: spiderPx,
            top: containerHeight - spiderPx,
            transformOrigin: "50% 30%",
          }}
        >
          <div className="spider-spin block" style={maskStyle} aria-hidden="true" />
        </div>
      </div>
      {label && (
        <div className="text-xs font-semibold text-slate-500 dark:text-slate-400">
          {label}
        </div>
      )}
    </div>
  );
}
